import { render, staticRenderFns } from "./EmailAddressField.vue?vue&type=template&id=49abdff0&scoped=true&"
import script from "./EmailAddressField.vue?vue&type=script&lang=js&"
export * from "./EmailAddressField.vue?vue&type=script&lang=js&"
import style0 from "./EmailAddressField.vue?vue&type=style&index=0&id=49abdff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49abdff0",
  null
  
)

export default component.exports